import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    leaguesLoading: true,
    pendingTeam: null,
    pendingTeamLoading: true,
    currentSeason: null,
    upcomingSeason: null,
    schedule: null,
    tournamentsLoading: true,
    upcomingTournaments: [],
    // `null` - haven't even started loading
    // `true` - in the process of loading
    // `false` - finished loading; not loading anymore
    galleryImagesLoading: null,
    galleryImages: [],
    // Same as `galleryImagesLoading`
    externalAdsLoading: null,
    externalAds: [],
    // Same as `galleryImagesLoading`
    faqsLoading: null,
    faqs: [],
  },
  mutations: {
    initialLeaguesData(state, data) {
      state.currentSeason = data.currentSeason;
      state.upcomingSeason = data.upcomingSeason;
    },
    initialLeaguesLoad(state) {
      state.leaguesLoading = false;
    },
    pendingTeamData(state, data) {
      state.pendingTeam = data;
    },
    pendingTeamLoad(state) {
      state.pendingTeamLoading = false;
    },
    initialTournamentsData(state, data) {
      state.upcomingTournaments = data.upcomingTournaments;
    },
    initialTournamentsLoad(state) {
      state.tournamentsLoading = false;
    },
    galleryImagesLoading(state) {
      state.galleryImagesLoading = true;
    },
    galleryImagesData(state, data) {
      state.galleryImages = data
      state.galleryImagesLoading = false;
    },
    externalAdsLoading(state) {
      state.externalAdsLoading = true;
    },
    externalAdsData(state, data) {
      state.externalAds = data
      state.externalAdsLoading = false;
    },
    faqsLoading(state) {
      state.faqsLoading = true;
    },
    faqsData(state, data) {
      state.faqs = data
      state.faqsLoading = false;
    }
  },
  getters: {
    signupsAvailable(state) {
      let season = state.upcomingSeason || state.currentSeason;
      if (!season) return false;
      let end = moment(season.signupsEnd).toDate();
      let now = moment().toDate();
      return now < end;
    },
    scheduleAvailable(state) {
      return state.currentSeason != null && !state.currentSeason.finished
    },
    matchSorter: (state, getters) => (m1, m2) => {
      let m1Date = moment(m1.date);
      let m2Date = moment(m2.date);
      if (m1Date.format() == m2Date.format()) {
        let m1Split = m1.time.split(":");
        let m2Split = m2.time.split(":");
        let m1TimeNumber = +m1Split[0] * 60 + m1Split[1];
        let m2TimeNumber = +m2Split[0] * 60 + m2Split[1];
        if (m1TimeNumber == m2TimeNumber) {
          if (m1.court == m2.court) return 0;
          return m1.court < m2.court ? -1 : 1;
        }
        return m1TimeNumber < m2TimeNumber ? -1 : 1;
      }
      return m1Date < m2Date ? -1 : 1;
    },
    groupedMatches: (state, getters) => (season, matches) => {
      let leagues = season.leagues;
      let grouped = {};
      for (let league of leagues) {
        grouped[league.id] = {league: league, matches: [], date: null};
      }
      matches.forEach(match => {
        // The league in a match refers to the ID of the league
        grouped[match.league].matches.push(match);
      });
      // Sort the matches
      for (let group of Object.values(grouped)) {
        group.matches.sort(getters.matchSorter);
      }
      // Now get the groups into the format we desire
      let groups = Array.from(Object.values(grouped));
      groups = groups.filter(g => g.matches.length > 0);
      const dayOrder = {
        "Mon": 1,
        "Tue": 2,
        "Wed": 3,
        "Thu": 4,
        "Fri": 5,
        "Sat": 6,
        "Sun": 7
      };
      groups.sort((g1, g2) => {
        let d1 = dayOrder[g1.league.day];
        let d2 = dayOrder[g2.league.day];
        return d1 == d2 ? 0 : d1 < d2 ? -1 : 1;
      });
      return groups;
    }
  },
  actions: {
    loadInitialLeaguesData(context) {
      return axios.get(`${Vue.apiRoot}/sharkeys-leagues-home/`).then(function(response) {
        context.commit("initialLeaguesData", response.data);
        context.commit("initialLeaguesLoad");
      });
    },
    loadPendingTeamData(context, data) {
      let url = `${Vue.apiRoot}/leagues-pending-teams/${data.seasonId}/${data.leagueId}/${data.pendingTeamId}/`;
      return axios.get(url).then(function(response) {
        context.commit("pendingTeamData", response.data);
        context.commit("pendingTeamLoad");
      });
    },
    loadInitialTournamentsData(context) {
      return axios.get(`${Vue.apiRoot}/sharkeys-tournaments-home/`).then(function(response) {
        context.commit("initialTournamentsData", response.data);
        context.commit("initialTournamentsLoad");
      });
    },
    loadGalleryImages(context) {
      context.commit("galleryImagesLoading");
      return axios.get(`${Vue.apiRoot}/gallery-images/`).then(function(response) {
        context.commit("galleryImagesData", response.data);
      });
    },
    loadExternalAds(context) {
      context.commit("externalAdsLoading");
      return axios.get(`${Vue.apiRoot}/external-advertisements/`).then(function(response) {
        context.commit("externalAdsData", response.data);
      });
    },
    loadFaqs(context) {
      context.commit("faqsLoading");
      return axios.get(`${Vue.apiRoot}/html-sections/?name=FAQs`).then(function(response) {
        context.commit("faqsData", response.data);
      });
    }
  }
})
